<template>

    <modal :show="show" @closeModal="cancel">

        <div class="mllf__container">

            <img class="mllf__img" src="/img/foxy/connect-grey.svg">

            <h1 class="mllf__title">{{ $t('login_fail_credentials_title') }}</h1>

            <p class="mllf__subtitle">{{ $t('login_fail_credentials_description') }}</p>

            <button class="btn btn-blue btn-big mllf__btn" @click="closeModal">{{ $t('login_fail_credentials_cta') }}</button>

        </div>

    </modal>

</template>

<script>

import Modal from '@/components/modal/Modal'

import Tag from '@/modules/tag'

export default {

    name: 'modal-login-long-failed',

    components: {Modal},

    data() {
        return {
            show: false
        }
    },

    methods: {

        open(provider) {
            this.show = true
            Tag.popupAll(this, 'login_fail_credentials', provider)
        },

        closeModal(email = false) {
            this.$emit('close', email)
            this.show = false
        },

        cancel() {
            this.closeModal()
        }

    }

}

</script>

<style lang="scss" scoped>

.mllf {
    &__container {
        max-width: 480px;
        padding: 24px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    &__img {
        width: 72px;
        object-fit: contain;
    }

    &__title {
        margin-top: 24px;
        font-size: 24px;
        font-weight: 500;
        line-height: 1.17;
        text-align: left;
        color: $charcoal;
    }

    &__subtitle {
        margin-top: 8px;
        font-size: 17px;
        line-height: 1.41;
        text-align: left;
        color: $moon;
    }

    &__btn {
        margin-top: 24px;
    }
}

</style>
